import { Box, Typography } from "@mui/material"
import usePageTitle from "../hooks/usePageTitle"

export default function Hotel() {
    usePageTitle("Übernachtung im Zollenspieker Fährhaus");

    return <Box maxWidth="1280px" sx={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '1rem' }}>
       

        <Typography mt="0.5rem" textAlign="justify">
            Es gibt für euch die Möglichkeit am nächsten Morgen mit uns im Hotel zu frühstücken. 
            Dies könnt ihr bei der Buchung eines Hotelzimmers mit angeben. 
            Auch wenn ihr nicht im Hotel übernachtet könnt ihr zum Frühstück ins Hotel kommen. 
            Bitte gebt uns dazu eine Rückmeldung über das Formular auf dieser Website. Frühstück gibt es für 28 € pro Person.
        </Typography>


    </Box>
}